<template>
  <div v-if="loadingStore.isLoading" class="loading-overlay">
    <div class="loading-content">
      <div class="spinner-border loading-spinner" role="status">
        <span class="visually-hidden">{{ t('common.loading') }}</span>
      </div>
      <p class="loading-text">{{ t('common.loading') }}</p>
    </div>
  </div>
</template>

<script setup>
import { useLoadingStore } from '@/stores/loadingStore'
import { useLanguage } from '@/composables/useLanguage'

const loadingStore = useLoadingStore()
const { t } = useLanguage()
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  pointer-events: auto;
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  color: #5ba6a0;
  border-width: 4px;
}

.loading-text {
  color: #ffffff;
  font-size: 18px;
  font-weight: 500;
  margin: 0;
  text-align: center;
  max-width: 200px;
}
</style>
